import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const translations = {
  ar: {
    "app.client": "عميل", "app.admin": "إدارة", "app.merchant": "تاجر",
    "common.loading": "جاري التحميل", "common.save": "حفظ", "common.cancel": "إلغاء", "common.close": "إغلاق",
    "common.confirm": "تأكيد", "common.back": "العودة", "common.copy": "نسخ", "common.copied": "تم النسخ",
    "common.amount": "المبلغ", "common.currency": "العملة", "common.status": "الحالة", "common.actions": "الإجراءات",
    "common.create": "إنشاء", "common.optional": "اختياري", "common.active": "مفعّلة", "common.frozen": "موقوفة",
    "common.closed": "مغلقة", "common.date": "التاريخ", "common.name": "الاسم", "common.error": "حدث خطأ ما",

    "auth.login": "تسجيل الدخول", "auth.register": "إنشاء حساب", "auth.loginSub": "أدخل بياناتك للوصول إلى محفظتك",
    "auth.registerSub": "ابدأ رحلتك المصرفية الرقمية", "auth.email": "البريد الإلكتروني", "auth.password": "كلمة المرور",
    "auth.fullName": "الاسم الكامل", "auth.enter": "دخول", "auth.createBtn": "إنشاء الحساب",
    "auth.noAccount": "ليس لديك حساب؟", "auth.haveAccount": "لديك حساب؟", "auth.welcome": "مرحباً بك في OB PAY",
    "auth.created": "تم إنشاء حسابك بنجاح", "auth.heroTitle": "المحفظة المتعددة العملات",
    "auth.heroSub": "نظام مصرفي رقمي عالمي. حساب مستقل لكل عملة برقم حساب و IBAN و QR خاص.",
    "auth.joinTitle": "انضم إلى OB PAY", "auth.joinSub": "أنشئ محفظتك واحصل على حسابات مستقلة لكل عملة بضغطة زر.",

    "nav.wallet": "محفظتي", "nav.transfer": "تحويل بين حساباتي", "nav.send": "إرسال أموال",
    "nav.cards": "بطاقاتي", "nav.merchant": "بوابة الدفع", "nav.adminPanel": "لوحة الإدارة",
    "nav.dashboard": "لوحة المعلومات", "nav.currencies": "إدارة العملات", "nav.rates": "أسعار الصرف",
    "nav.users": "المستخدمون", "nav.gateway": "إعدادات البوابة", "nav.merchants": "التجار",
    "nav.clientView": "محفظتي (واجهة العميل)", "nav.logout": "تسجيل الخروج",

    "dash.title": "محفظتي", "dash.sub": "نظرة عامة على جميع حساباتك بالعملات المختلفة",
    "dash.newAccount": "حساب جديد", "dash.totalBalance": "إجمالي الرصيد بالعملة الأساسية",
    "dash.activeAccounts": "حساب نشط", "dash.rates": "أسعار الصرف الداخلية",
    "dash.myAccounts": "حساباتي", "dash.transferBetween": "تحويل بين الحسابات",
    "dash.empty": "لا توجد حسابات بعد. افتح حساب عملة للبدء.", "dash.openAccount": "فتح حساب",
    "dash.openNew": "فتح حساب عملة جديد", "dash.allCurrencies": "لديك حسابات بكل العملات المتاحة.",
    "dash.default": "افتراضي", "dash.available": "الرصيد المتاح", "dash.pending": "معلّق",
    "dash.accountNo": "رقم الحساب", "dash.setDefault": "تم تعيين الحساب الافتراضي", "dash.created": "تم إنشاء حساب",

    "acct.deposit": "إيداع رصيد", "acct.deposit.btn": "إيداع", "acct.deposited": "تم الإيداع بنجاح",
    "acct.walletNo": "رقم المحفظة", "acct.qrTitle": "رمز الاستقبال QR", "acct.qrSub": "شارك هذا الرمز لاستقبال الأموال",
    "acct.close": "إغلاق الحساب", "acct.closeConfirm": "هل تريد إغلاق هذا الحساب؟", "acct.closed": "تم إغلاق الحساب",
    "acct.statement": "كشف الحساب وسجل العمليات", "acct.noTxns": "لا توجد عمليات بعد.", "acct.pendingBal": "رصيد معلّق",

    "tr.title": "تحويل بين حساباتي", "tr.sub": "حوّل بين عملاتك المختلفة بسعر الصرف الحالي",
    "tr.from": "من حساب", "tr.to": "إلى حساب", "tr.pickFrom": "اختر الحساب المصدر", "tr.pickTo": "اختر الحساب الوجهة",
    "tr.rate": "سعر الصرف", "tr.fee": "الرسوم", "tr.willReceive": "سيصل إلى الوجهة", "tr.execute": "تنفيذ التحويل",
    "tr.done": "تم التحويل", "tr.sameAcct": "لا يمكن التحويل لنفس الحساب", "tr.badAmount": "أدخل مبلغاً صحيحاً",
    "tr.noRate": "لا يوجد سعر صرف لهذا الزوج", "tr.pickAccts": "اختر الحسابات",

    "send.title": "إرسال أموال", "send.sub": "أرسل إلى أي حساب OB PAY باستخدام رقم الحساب",
    "send.from": "من حساب", "send.pickFrom": "اختر حسابك", "send.toNumber": "رقم حساب المستلم",
    "send.note": "ملاحظة (اختياري)", "send.notePh": "سبب التحويل", "send.btn": "إرسال", "send.done": "تم إرسال الأموال بنجاح",
    "send.crossNote": "يدعم الإرسال بين عملات مختلفة مع تطبيق سعر الصرف تلقائياً.",
    "send.noFrom": "اختر الحساب المصدر", "send.noTo": "أدخل رقم حساب المستلم",

    "cards.title": "بطاقات OBCARD", "cards.sub": "أصدر بطاقات افتراضية مرتبطة بحساباتك للدفع عبر الإنترنت",
    "cards.issue": "إصدار بطاقة", "cards.issueTitle": "إصدار بطاقة OBCARD جديدة", "cards.empty": "لا توجد بطاقات بعد.",
    "cards.linkedAccount": "الحساب المرتبط", "cards.holderName": "اسم حامل البطاقة", "cards.holderPh": "كما يظهر على البطاقة",
    "cards.type": "نوع البطاقة", "cards.virtual": "افتراضية", "cards.physical": "فعلية (قريباً)",
    "cards.label": "تسمية البطاقة", "cards.issueBtn": "إصدار البطاقة", "cards.issued": "تم إصدار البطاقة",
    "cards.expires": "تنتهي", "cards.cvv": "CVV", "cards.freeze": "تجميد", "cards.unfreeze": "تفعيل",
    "cards.closeCard": "إغلاق", "cards.statusUpdated": "تم تحديث حالة البطاقة", "cards.showDetails": "إظهار البيانات",
    "cards.hideDetails": "إخفاء", "cards.balance": "رصيد الحساب", "cards.noAccount": "أنشئ حساب عملة أولاً لإصدار بطاقة.",

    "mer.title": "بوابة الدفع", "mer.becomeTitle": "كن تاجراً واقبل المدفوعات",
    "mer.becomeSub": "اربط API بموقعك واستقبل المدفوعات ببطاقات OBCARD ورصيد OB PAY والبطاقات البنكية.",
    "mer.businessName": "اسم النشاط التجاري", "mer.settlement": "حساب التسوية (يستلم الأموال)",
    "mer.webhook": "رابط Webhook (اختياري)", "mer.register": "تفعيل حساب التاجر", "mer.registered": "تم تفعيل حساب التاجر",
    "mer.needAccount": "أنشئ حساب عملة أولاً لاستخدامه كحساب تسوية.", "mer.keys": "مفاتيح API",
    "mer.publicKey": "المفتاح العام (Publishable)", "mer.secretKey": "المفتاح السري (Secret)",
    "mer.regenerate": "إعادة توليد المفاتيح", "mer.regenConfirm": "إعادة توليد المفاتيح ستُبطل المفاتيح الحالية. متابعة؟",
    "mer.regenerated": "تم توليد مفاتيح جديدة", "mer.payments": "المدفوعات", "mer.noPayments": "لا توجد مدفوعات بعد.",
    "mer.settings": "إعدادات التاجر", "mer.saveSettings": "حفظ الإعدادات", "mer.saved": "تم الحفظ",
    "mer.apiDocs": "توثيق API", "mer.apiDocsSub": "أنشئ طلب دفع من خادمك ثم وجّه العميل إلى رابط الدفع",
    "mer.fee": "الرسوم", "mer.net": "الصافي", "mer.method": "الوسيلة", "mer.testCharge": "إنشاء دفعة تجريبية",
    "mer.testChargeDone": "تم إنشاء دفعة تجريبية — افتح رابط الدفع",

    "co.title": "إتمام الدفع", "co.payTo": "الدفع إلى", "co.amountDue": "المبلغ المستحق",
    "co.method": "اختر وسيلة الدفع", "co.obBalance": "رصيد OB PAY", "co.obcard": "بطاقة OBCARD",
    "co.bankCard": "بطاقة بنكية (Visa / MasterCard)", "co.applePay": "Apple Pay (قريباً)", "co.googlePay": "Google Pay (قريباً)",
    "co.cardNumber": "رقم البطاقة", "co.expiry": "تاريخ الانتهاء", "co.payNow": "ادفع الآن", "co.selectAccount": "اختر الحساب",
    "co.loginHint": "سجّل الدخول للدفع من رصيدك", "co.success": "تم الدفع بنجاح", "co.paid": "تم الدفع",
    "co.alreadyPaid": "تمت معالجة هذه الدفعة مسبقاً", "co.sandbox": "وضع تجريبي — أدخل أي رقم بطاقة",
    "co.securedBy": "دفع آمن عبر", "co.month": "شهر", "co.year": "سنة",

    "adm.dashTitle": "لوحة معلومات الإدارة", "adm.dashSub": "نظرة شاملة على النظام والسيولة والمستخدمين",
    "adm.liquidity": "إجمالي السيولة بالعملة الأساسية", "adm.users": "المستخدمون", "adm.activeAccounts": "الحسابات النشطة",
    "adm.currencies": "العملات", "adm.ratePairs": "أزواج الصرف", "adm.totalTxns": "إجمالي العمليات", "adm.admins": "مدير",
    "adm.activeC": "مفعّلة", "adm.usersTitle": "المستخدمون", "adm.allUsers": "جميع مستخدمي النظام",
    "adm.role": "الدور", "adm.accounts": "الحسابات", "adm.gwTitle": "إعدادات بوابة الدفع",
    "adm.gwSub": "رسوم البوابة الافتراضية المطبقة على معاملات التجار", "adm.gwPct": "نسبة الرسوم (%)",
    "adm.gwFixed": "رسوم ثابتة", "adm.gwFeeCur": "عملة الرسوم", "adm.gwSaved": "تم حفظ الإعدادات",
    "adm.merchantsTitle": "التجار", "adm.business": "النشاط", "adm.merchantPayments": "المدفوعات",
    "adm.customFees": "رسوم مخصصة", "adm.setFees": "تعيين رسوم", "adm.feesSaved": "تم حفظ رسوم التاجر",

    "cur.manageTitle": "إدارة العملات", "cur.manageSub": "إضافة وتعديل وتفعيل العملات وتحديد العملة الأساسية والرسوم",
    "cur.new": "عملة جديدة", "cur.base": "أساسية", "rate.manageTitle": "أسعار الصرف",
    "rate.manageSub": "تحديث يدوي لأسعار الشراء والبيع والتحويل الداخلي مع سجل كامل", "rate.update": "تحديث سعر",
    "rate.history": "السجل",
    "Deposit": "إيداع",
    "Withdraw": "سحب",
    "Transfer": "تحويل",
    "Exchange": "مصارفة",
    "Saved": "تم الحفظ",
    "edit": "تعديل",
    "add_currency": "إضافة عملة جديدة",
    "currency_code": "الرمز (USD)",
    "The_abbreviated_symbol": "الرمز المختصر ($)",
    "Name_English": "الاسم (English)",
    "Name_Arabic": "الاسم (Arabic)",
    "Activated": " مفعّلة",
    "save": "حفظ",
    "became_default_currency": "أصبحت العملة الأساسية",
    "delete_currency": "حذف العملة",
    "Deleted": "تم الحذف",
    "Currency_Management": "إدارة العملات ",
    "Add_modify_and_activate_currencies_set_the_base_currency_and_fees": "إضافة وتعديل وتفعيل العملات وتحديد العملة الأساسية والرسوم",
    "Decimal": "المنازل",
    "Active": "مفعلة",
    "Basic_assignment": "تعيين أساسية",
  },
  en: {
    "app.client": "Client", "app.admin": "Admin", "app.merchant": "Merchant",
    "common.loading": "Loading", "common.save": "Save", "common.cancel": "Cancel", "common.close": "Close",
    "common.confirm": "Confirm", "common.back": "Back", "common.copy": "Copy", "common.copied": "Copied",
    "common.amount": "Amount", "common.currency": "Currency", "common.status": "Status", "common.actions": "Actions",
    "common.create": "Create", "common.optional": "optional", "common.active": "Active", "common.frozen": "Frozen",
    "common.closed": "Closed", "common.date": "Date", "common.name": "Name", "common.error": "Something went wrong",

    "auth.login": "Sign In", "auth.register": "Create Account", "auth.loginSub": "Enter your details to access your wallet",
    "auth.registerSub": "Start your digital banking journey", "auth.email": "Email", "auth.password": "Password",
    "auth.fullName": "Full Name", "auth.enter": "Login", "auth.createBtn": "Create Account",
    "auth.noAccount": "Don't have an account?", "auth.haveAccount": "Already have an account?", "auth.welcome": "Welcome to OB PAY",
    "auth.created": "Your account has been created", "auth.heroTitle": "The Multi-Currency Wallet",
    "auth.heroSub": "A global digital bank. An independent account per currency with its own number, IBAN and QR.",
    "auth.joinTitle": "Join OB PAY", "auth.joinSub": "Create your wallet and get independent accounts for every currency.",

    "nav.wallet": "My Wallet", "nav.transfer": "Transfer", "nav.send": "Send Money",
    "nav.cards": "My Cards", "nav.merchant": "Payment Gateway", "nav.adminPanel": "Admin Panel",
    "nav.dashboard": "Dashboard", "nav.currencies": "Currencies", "nav.rates": "Exchange Rates",
    "nav.users": "Users", "nav.gateway": "Gateway Settings", "nav.merchants": "Merchants",
    "nav.clientView": "My Wallet (client view)", "nav.logout": "Logout",

    "dash.title": "My Wallet", "dash.sub": "Overview of all your accounts across currencies",
    "dash.newAccount": "New Account", "dash.totalBalance": "Total Balance in Base Currency",
    "dash.activeAccounts": "active accounts", "dash.rates": "Internal Exchange Rates",
    "dash.myAccounts": "My Accounts", "dash.transferBetween": "Transfer between accounts",
    "dash.empty": "No accounts yet. Open a currency account to begin.", "dash.openAccount": "Open Account",
    "dash.openNew": "Open a new currency account", "dash.allCurrencies": "You have accounts in every available currency.",
    "dash.default": "Default", "dash.available": "Available Balance", "dash.pending": "Pending",
    "dash.accountNo": "Account No.", "dash.setDefault": "Default account set", "dash.created": "Account created",

    "acct.deposit": "Deposit Funds", "acct.deposit.btn": "Deposit", "acct.deposited": "Deposit successful",
    "acct.walletNo": "Wallet No.", "acct.qrTitle": "Receive QR Code", "acct.qrSub": "Share this code to receive money",
    "acct.close": "Close Account", "acct.closeConfirm": "Close this account?", "acct.closed": "Account closed",
    "acct.statement": "Statement & Transaction History", "acct.noTxns": "No transactions yet.", "acct.pendingBal": "Pending balance",

    "tr.title": "Transfer between my accounts", "tr.sub": "Convert between your currencies at the current rate",
    "tr.from": "From account", "tr.to": "To account", "tr.pickFrom": "Select source account", "tr.pickTo": "Select destination account",
    "tr.rate": "Exchange rate", "tr.fee": "Fee", "tr.willReceive": "Recipient gets", "tr.execute": "Execute Transfer",
    "tr.done": "Transfer complete", "tr.sameAcct": "Cannot transfer to the same account", "tr.badAmount": "Enter a valid amount",
    "tr.noRate": "No exchange rate for this pair", "tr.pickAccts": "Select accounts",

    "send.title": "Send Money", "send.sub": "Send to any OB PAY account using the account number",
    "send.from": "From account", "send.pickFrom": "Select your account", "send.toNumber": "Recipient account number",
    "send.note": "Note (optional)", "send.notePh": "Transfer reason", "send.btn": "Send", "send.done": "Money sent successfully",
    "send.crossNote": "Supports cross-currency sending with automatic exchange rate.",
    "send.noFrom": "Select source account", "send.noTo": "Enter recipient account number",

    "cards.title": "OBCARD Cards", "cards.sub": "Issue virtual cards linked to your accounts for online payments",
    "cards.issue": "Issue Card", "cards.issueTitle": "Issue a new OBCARD", "cards.empty": "No cards yet.",
    "cards.linkedAccount": "Linked account", "cards.holderName": "Cardholder name", "cards.holderPh": "As shown on card",
    "cards.type": "Card type", "cards.virtual": "Virtual", "cards.physical": "Physical (soon)",
    "cards.label": "Card label", "cards.issueBtn": "Issue Card", "cards.issued": "Card issued",
    "cards.expires": "Expires", "cards.cvv": "CVV", "cards.freeze": "Freeze", "cards.unfreeze": "Unfreeze",
    "cards.closeCard": "Close", "cards.statusUpdated": "Card status updated", "cards.showDetails": "Show details",
    "cards.hideDetails": "Hide", "cards.balance": "Account balance", "cards.noAccount": "Create a currency account first to issue a card.",

    "mer.title": "Payment Gateway", "mer.becomeTitle": "Become a merchant & accept payments",
    "mer.becomeSub": "Integrate the API into your site and accept payments via OBCARD, OB PAY balance and bank cards.",
    "mer.businessName": "Business name", "mer.settlement": "Settlement account (receives funds)",
    "mer.webhook": "Webhook URL (optional)", "mer.register": "Activate Merchant Account", "mer.registered": "Merchant account activated",
    "mer.needAccount": "Create a currency account first to use as a settlement account.", "mer.keys": "API Keys",
    "mer.publicKey": "Publishable Key", "mer.secretKey": "Secret Key",
    "mer.regenerate": "Regenerate Keys", "mer.regenConfirm": "Regenerating keys will invalidate current keys. Continue?",
    "mer.regenerated": "New keys generated", "mer.payments": "Payments", "mer.noPayments": "No payments yet.",
    "mer.settings": "Merchant settings", "mer.saveSettings": "Save settings", "mer.saved": "Saved",
    "mer.apiDocs": "API Documentation", "mer.apiDocsSub": "Create a charge from your server then redirect the customer to the checkout URL",
    "mer.fee": "Fee", "mer.net": "Net", "mer.method": "Method", "mer.testCharge": "Create test charge",
    "mer.testChargeDone": "Test charge created — open checkout link",

    "co.title": "Checkout", "co.payTo": "Pay to", "co.amountDue": "Amount due",
    "co.method": "Choose payment method", "co.obBalance": "OB PAY Balance", "co.obcard": "OBCARD",
    "co.bankCard": "Bank Card (Visa / MasterCard)", "co.applePay": "Apple Pay (soon)", "co.googlePay": "Google Pay (soon)",
    "co.cardNumber": "Card number", "co.expiry": "Expiry", "co.payNow": "Pay Now", "co.selectAccount": "Select account",
    "co.loginHint": "Log in to pay from your balance", "co.success": "Payment successful", "co.paid": "Paid",
    "co.alreadyPaid": "This payment has already been processed", "co.sandbox": "Sandbox mode — enter any card number",
    "co.securedBy": "Secured by", "co.month": "MM", "co.year": "YYYY",

    "adm.dashTitle": "Admin Dashboard", "adm.dashSub": "System-wide overview of liquidity and users",
    "adm.liquidity": "Total Liquidity in Base Currency", "adm.users": "Users", "adm.activeAccounts": "Active Accounts",
    "adm.currencies": "Currencies", "adm.ratePairs": "Rate Pairs", "adm.totalTxns": "Total Transactions", "adm.admins": "admins",
    "adm.activeC": "active", "adm.usersTitle": "Users", "adm.allUsers": "All system users",
    "adm.role": "Role", "adm.accounts": "Accounts", "adm.gwTitle": "Payment Gateway Settings",
    "adm.gwSub": "Default gateway fees applied to merchant transactions", "adm.gwPct": "Fee percentage (%)",
    "adm.gwFixed": "Fixed fee", "adm.gwFeeCur": "Fee currency", "adm.gwSaved": "Settings saved",
    "adm.merchantsTitle": "Merchants", "adm.business": "Business", "adm.merchantPayments": "Payments",
    "adm.customFees": "Custom fees", "adm.setFees": "Set fees", "adm.feesSaved": "Merchant fees saved",

    "cur.manageTitle": "Currency Management", "cur.manageSub": "Add, edit, activate currencies, set base currency and fees",
    "cur.new": "New Currency", "cur.base": "Base", "rate.manageTitle": "Exchange Rates",
    "rate.manageSub": "Manual update of buy, sell and internal rates with full history", "rate.update": "Update Rate",
    "rate.history": "History",
    "Deposit": "Deposit",
    "Withdraw": "Withdraw",
    "Transfer": "Transfer",
    "Exchange": "Exchange",
    "Saved": "Saved",
    "edit": "Edit",
    "add_currency": "Add Currency",
    "currency_code": "The symbol (USD)",
    "The_abbreviated_symbol": "The abbreviated symbol ($)",
    "Name_English": "Name (English)",
    "Name_Arabic": "Name (Arabic)",
    "Activated": "Activated",
    "save": "Save",
    "became_default_currency": "Became default currency",
    "delete_currency": "Delete currency",
    "Deleted": "Deleted",
    "Currency_Management": "Currency Management ",
    "Add_modify_and_activate_currencies_set_the_base_currency_and_fees": "Add, modify, and activate currencies, set the base currency and fees",
    "Decimal": "Decimal",
    "Active": "Active",
    "Basic_assignment": "Basic assignment",
  },
};

const I18nContext = createContext(null);
export const useI18n = () => useContext(I18nContext);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ob_lang") || "ar");
  const dir = lang === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
  }, [lang, dir]);

  const setLang = useCallback((l) => {
    localStorage.setItem("ob_lang", l);
    setLangState(l);
  }, []);

  const toggle = useCallback(() => setLang(lang === "ar" ? "en" : "ar"), [lang, setLang]);

  const t = useCallback((key) => translations[lang][key] ?? translations.ar[key] ?? key, [lang]);

  return (
    <I18nContext.Provider value={{ lang, dir, setLang, toggle, t }}>
      <div dir={dir}>{children}</div>
    </I18nContext.Provider>
  );
}
